export const getAddedFavorites = (current, next) =>
    next.filter((channel) => !current.includes(channel));

export const getDeletedFavorites = (current, next) =>
    current.filter((channel) => !next.includes(channel));
